export class Deposit {
  type: string;
  currency: string;
  amount: number;
  rate: number;
  fee: number;
  partner_id: string;
  branch_code: string;
}


export const DepositType = {
  'AccountDeposit': 'Account Deposit',
  'Cash': 'Cash'
  // 'RDA' : 'RDA'
};

export class DepositTypeValues {
  list = DepositType;
  getList(): Array<string> {
    return Object.keys(this.list);
  }
}

export const Bank = {
  '002': 'KDB산업은행',
  '003': 'IBK기업은행',
  '004': 'KB국민은행',
  '006': 'KB국민은행(구 주택은행)',
  '007': '수협은행(수협중앙회)',
  '030': '수협은행(수협중앙회)',
  '011': 'NH농협은행',
  '012': '농협중앙회',
  '020': '우리은행',
  '023': 'SC제일은행',
  '031': '대구은행',
  '032': '부산은행',
  '034': '광주은행',
  '035': '제주은행',
  '037': '전북은행',
  '039': '경남은행',
  '045': '새마을금고중앙회',
  '050': '저축은행중앙회',
  '081': 'KEB하나은행',
  '088': '신한은행',

  /** 191218 이후로 오픈뱅킹에 추가됨 */
  '027': '한국씨티은행',
  '089': '케이뱅크',
  '090': '카카오뱅크',

  /** 201211 이후 적용 */
  '048': '신용협동조합중앙회',
  '064': '산림조합중앙회',
  '071': '우정사업본부(우체국)',
  '218': 'KB증권',
  '238': '미래에셋대우',
  '240': '삼성증권',
  '243': '한국투자증권',
  '247': 'NH투자증권',
  '261': '교보증권',
  '262': '하이투자증권',
  '263': '현대차증권',
  '264': '키움증권',
  '265': '이베스트투자증권',
  '266': 'SK 증권',
  '267': '대신증권',
  '269': '한화투자증권',
  '278': '신한금융투자',
  '279': 'DB 금융투자',
  '280': '유진투자증권',
  '287': '메리츠증권',

  /** 211005 이후 적용 */
  '092': '토스뱅크'

  /** 테스트 용도 */
  // ,'296': '오픈증권'
};

export class KoreaBankCode {
  list = Bank;
  getList(): Array<string> {
      return Object.keys(this.list);
  }
}

export const VoucherBank = {
  '002': 'Development(KDB)',
  '003': 'Industrial(IBK)',
  '004': 'Kookmin',
  '006': 'Kookmin',
  '007': 'Suhyup',
  '030': 'Suhyup',
  '011': 'Nonghyup',
  '012': 'Nonghyup',
  '020': 'Woori',
  '023': 'Standard Chartered',
  '027': 'Citi',
  '031': 'Daegu',
  '032': 'Busan',
  '034': 'Kwangju',
  '035': 'Jeju',
  '037': 'Jeonbuk',
  '039': 'Kyongnam',
  '045': 'KFCC',
  '050': 'FSB',
  '081': 'KEB Hana',
  '088': 'Shinhan',

  /** 191218 이후로 오픈뱅킹에 추가됨 */
  '089': 'K-Bank',
  '090': 'Kakao',

  /** 201211 이후 적용 */
  '048': 'Shinhyup',
  '064': 'NFCF',
  '071': 'Postoffice',
  '218': 'KB sec.',
  '238': 'Miraeassetdaewoo sec.',
  '240': 'Samsung sec.',
  '243': 'Hantoo sec.',
  '247': 'NH sec.',
  '261': 'Kyobo sec.',
  '262': 'Hi sec.',
  '263': 'Hyundai sec.',
  '264': 'Kiwoom sec.',
  '265': 'eBest sec.',
  '266': 'SK sec.',
  '267': 'Daeshin sec.',
  '269': 'Hanhwa sec.',
  '278': 'Shinhan sec.',
  '279': 'DB sec.',
  '280': 'YJ sec.',
  '287': 'Meritz sec.',

  /** 211005 이후 적용 */
  '092': 'Toss Bank'

  /** For Test */
  // ,'296': 'Open sec.'
};



// WEBPACK FOOTER //
// ./src/app/model/shared/transaction/deposit.ts